export const LIBRARY_NAME = '@wallaby-ui/layout';

export default {LIBRARY_NAME};
